module.exports = __webpack_public_path__ + "img/9.3c42f63e.svg";